import React from "react";
import "./LegalPages.css";

function PrivacyPolicy() { 
  return (
    <div className="legal-page-wrapper">
      {/* Hero Banner */}
      <section className="legal-hero" style={{
    backgroundImage: "url('/images/bread.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}>
        <div className="hero-overlay-mask"></div>
        <div className="hero-content-box">
          <h1 className="hero-main-title" style={{
    textAlign: "center"
  }}>Privacy Policy</h1>
          <div className="hero-breadcrumb">
            <span className="breadcrumb-link">Home</span>
            <span className="breadcrumb-arrow">➔</span>
            <span className="breadcrumb-current">Privacy Policy</span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-main-section">
        <div className="legal-container">
          <div className="legal-document-card">
            <div className="document-header">
              <span className="meta-date">Last Updated: January 2024</span>
              <h2>Data Protection &amp; Confidentiality Mandate</h2>
              <p className="lead-text">
                At Anuk Charitable Trust, we are completely committed to protecting your privacy and ensuring the highest level of security for your personal and financial information.
              </p>
            </div>

            <div className="document-body">
              <h3>1. Information We Collect</h3>
              <p>
                We collect primary information when you voluntarily interact with our digital infrastructure, make online donations, register as a volunteer, or subscribe to our regional newsletters. This includes:
              </p>
              <ul>
                <li><strong>Personal Identifiers:</strong> Full name, complete postal address, email address, and mobile numbers.</li>
                <li><strong>Transaction Records:</strong> Official transaction numbers, specific contribution amounts, and occasion tags. (Note: We do not store sensitive bank credentials or primary UPI PINs directly on our servers).</li>
                <li><strong>Technical Data:</strong> IP addresses, browser specifications, and basic operational cookie tracking to optimize user navigation across our registry.</li>
              </ul>

              <h3>2. Utilization of Data</h3>
              <p>
                Your data is strictly deployed for operational verifications and transparent institutional auditing. Specifically, we use your records to:
              </p>
              <ul>
                <li>Process instant donation receipts and generate verifiable tax exemption certificates (80G).</li>
                <li>Dispatch synchronized administrative notifications and project progress updates directly via integrated WhatsApp channels.</li>
                <li>Comply with statutory regulatory directives enforced by the Pondicherry Government and central registries (DARPAN).</li>
              </ul>

              <h3>3. Non-Disclosure &amp; Third-Party Access</h3>
              <p>
                <strong>We absolutely do not sell, rent, or trade your personal information.</strong> Third-party access is restricted exclusively to vetted secure payment gateway facilitators (SBI) and authorized legal auditors bound by stringent non-disclosure parameters.
              </p>

              <h3>4. Security Safeguards</h3>
              <p>
                All data input pipelines utilize advanced encryption protocols (SSL). Physical access to localized registries is strictly limited to managing trustees and certified operational personnel.
              </p>

              <h3>5. Your Institutional Rights</h3>
              <p>
                You retain complete operational oversight over your registry profile. You may request copies of your archived logs, opt out of direct broadcast lists, or request profile purges by contacting our central administration.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;